import React, { useEffect, useState } from "react";
import { Typography, Table, Tag } from "antd";
import Employee from "../../../components/scheduling/tableItems/Employee";
import Date from "../../../components/scheduling/tableItems/Date";
import { useIntl } from "react-intl";
import moment from "moment";

const { Text } = Typography;
const SchedulingTable = (props) => {
  const { filteredOrders, events, loadLoading } = props;
  const intl = useIntl();
  const [items, setItems] = useState();

  useEffect(() => {
    let filtered = [];
    let ids = [];
    let selected = [];

    events.forEach((item, i) => {
      if (item.approved === true || item.approved === false) {
        ids.push({ id: item.id, approved: item.approved });
      }
      if (item.approved === true) {
        selected.push(item.id);
      }
      var isFiltered = filteredOrders.includes(item.order_id);
      if (!isFiltered) {
        filtered.push(item);
      }
    });
    setItems(filtered);
  }, [events, filteredOrders]);

  const columns = [
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.employee",
      }),
      dataIndex: "employee",
      render(text, record) {
        return <Employee record={record.employee} />;
      },
      sorter: (a, b) => a.employee.surename.localeCompare(b.employee.surename),
      sortDirections: ["descend", "ascend"],
      width: "150px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.date",
      }),
      dataIndex: "start",
      render(text, record) {
        return <Date text={text} format={"L"} />;
      },
      sorter: (a, b) => a.start.valueOf() - b.start.valueOf(),
      sortDirections: ["descend", "ascend"],
      width: "110px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.dayInWeek",
      }),
      responsive: ["lg"],
      dataIndex: "start",
      render(text, record) {
        return <Text>{moment.weekdays(moment(text).weekday())}</Text>;
      },
      width: "80px",
    },

    {
      title: intl.formatMessage({
        id: "app.scheduling.table.hours",
      }),
      responsive: ["md"],
      render(text, record) {
        return record.start ? (
          <Text>{`${moment(record.start).format("HH:mm")} : ${moment(
            record.end
          ).format("HH:mm")}`}</Text>
        ) : null;
      },
      width: "120px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.client",
      }),
      dataIndex: "client_name",
      responsive: ["lg"],
      render(text, record) {
        return <Text ellipsis={true}>{text}</Text>;
      },
      sorter: (a, b) => a.client_name.localeCompare(b.client_name),
      sortDirections: ["descend", "ascend"],
      width: "150px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.status",
      }),
      responsive: ["md"],
      dataIndex: "approved",
      render(text, record) {
        return text ? (
          <Tag color="success">
            {intl.formatMessage({
              id: "app.scheduling.table.verified",
            })}
          </Tag>
        ) : null;
      },
      width: "70px",
    },
  ];

  return (
    <div style={{ maxWidth: "760px" }}>
      <Table
        bordered
        pagination={false}
        columns={columns}
        dataSource={items}
        rowKey={(record) => record.id}
        scroll={{ y: window.innerHeight - 480 }}
        loading={loadLoading}
      />
    </div>
  );
};

export default SchedulingTable;
